// extracted by mini-css-extract-plugin
export default {"backgroundProgressBar":"ProgressBarStateCourse_backgroundProgressBar__o7HxJ","fillerProgressBar":"ProgressBarStateCourse_fillerProgressBar__0bOvd"};